// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","right":"Header_right__sCxx3","copyToClipboard":"Header_copyToClipboard__Ru-aT"};